## Camel

Click [Camel](camel) in the top navigation bar to view the running Camel Context in the current JVM. (The selection will not appear on the navigation bar if there is no Camel running).

The Camel plugin allows you to view all the running Camel applications in the current JVM.
You can among others see the following details:

- Lists of all running Camel applications
- Detailed information of each Camel Context such as Camel version number, runtime statics
- Lists of all routes in each Camel applications and their runtime statistics
- Manage the lifecycle of all Camel applications and their routes, so you can restart / stop / pause / resume, etc.
- Graphical representation of the running routes along with real time metrics
- Live tracing and debugging of running routes
- Profile the running routes with real time runtime statics; detailed specified per processor
- Browsing and sending messages to Camel endpoint
